export type ErrorCode = 'validation' | 'not_found' | 'conflict' | 'forbidden' | 'business_rule';

export class ValidationError extends Error {
  readonly code = 'validation' as const;
  constructor(public readonly details: unknown) {
    super('Błąd walidacji');
    this.name = 'ValidationError';
  }
}

export class NotFoundError extends Error {
  readonly code = 'not_found' as const;
  constructor(
    public readonly entity: string,
    public readonly id: string,
  ) {
    super(`Nie znaleziono: ${entity} ${id}`);
    this.name = 'NotFoundError';
  }
}

export class ConflictError extends Error {
  readonly code = 'conflict' as const;
  /** A conflict of its own kind (e.g. `history_moved`): said in the 409 body as `code`. */
  readonly conflictCode: string | undefined;
  constructor(
    public readonly entity: string,
    public readonly id: string,
    public readonly current: unknown,
    opts: { code?: string; message?: string } = {},
  ) {
    super(opts.message ?? `Konflikt wersji: ${entity} ${id}`);
    this.conflictCode = opts.code;
    this.name = 'ConflictError';
  }
}

export class ForbiddenError extends Error {
  readonly code = 'forbidden' as const;
  constructor(public readonly reason: string) {
    super(reason);
    this.name = 'ForbiddenError';
  }
}

export class BusinessRuleError extends Error {
  readonly code = 'business_rule' as const;
  constructor(
    public readonly ruleCode: string,
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = 'BusinessRuleError';
  }
}
